export default __webpack_public_path__ + "static/media/game_fg_full_2x.1535a4c5.png";